import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { generatePath } from 'react-router';
import util from 'util';
import constClass from '../../Constants/Constants';
import Common from '../Common/common';

const NavBar = (props) => {
  const { user, userActions, siteName, setting } = props;
  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleTitleClick = () => {
    console.log(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}login`);
    userActions.refresh();
    history.replace(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}`);
  };

  const handleLogoutClick = () => {
    console.log(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}login`);
    localStorage.removeItem('jwt');
    userActions.logout();
    history.replace(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}login`);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };


  // const handlePlanCategoryClick = () => {
  //   userActions.refresh();
  //   history.replace(`${props.match.path}plancategory`);
  // }

  // const handleProductCategoryClick = () => {
  //   userActions.refresh();
  //   history.replace(`${props.match.path}productcategory`);
  // }

  // const handleOrderInputClick = () => {
  //   userActions.refresh();
  //   history.replace(`${props.match.path}order/input`);
  // }

  // const handlePlanClick = () => {
  //   userActions.refresh();
  //   history.replace(`${props.match.path}plan`);
  // }

  // const handleProductClick = () => {
  //   userActions.refresh();
  //   history.replace(`${props.match.path}product`);
  // }

  return (
    <nav className="navbar navbar-light navbar-expand-lg  bg-light fixed-top">
      <Link className="navbar-brand text-center" onClick={handleTitleClick} to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}`}>
        {Common.getBrString(siteName)}<div className='d-none'>{util.inspect(history)}</div>
      </Link>
      {
        user.isLoggedIn &&
        <button className="navbar-toggler" type="button" onClick={toggleMenu} aria-controls="navbarNavDropdown" aria-expanded={menuOpen} aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      }
      {
        user.isLoggedIn && (
          <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id="navbarNavDropdown">
            <ul className="navbar-nav">
              {(user.userClass === constClass.USER_CLASS.MANAGER || user.userClass === constClass.USER_CLASS.MANAGERMALL) && (
                <li className="nav-item">
                  <Link className="nav-link" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })} onClick={handleLinkClick}>
                    お客様一覧
                  </Link>
                </li>
              )}
              {/* ポイント履歴や会員証読み取りなど、全員向け or STAFF向け */}
              {Common.getFunctionEnabled(setting, 'MEMBERCARD') && setting['MEMBER_CARD_CODE_TYPE'] === '2' && user.userClass === constClass.USER_CLASS.STAFF && (
                <li className="nav-item">
                  <Link className="nav-link" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'pointterminal'} onClick={handleLinkClick}>
                    会員証・クーポン読み取り
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link className="nav-link" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'pointhistory'} onClick={handleLinkClick}>
                  ポイント履歴
                </Link>
              </li>
              {(user.userClass === constClass.USER_CLASS.MANAGER || user.userClass === constClass.USER_CLASS.MANAGERMALL) && (
                <li className="nav-item dropdown">
                  <button className="nav-link nav-btn dropdown-toggle" id="navbarDropdownCoupon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    クーポン管理
                  </button>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownCoupon">
                    {Common.getFunctionEnabled(setting, 'COUPON') && (
                      <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'coupon'} onClick={handleLinkClick}>
                        クーポン管理
                      </Link>
                    )}
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'coupongroup'} onClick={handleLinkClick}>
                      クーポングループ管理
                    </Link>
                  </div>
                </li>
              )}
              {(user.userClass === constClass.USER_CLASS.MANAGER || user.userClass === constClass.USER_CLASS.MANAGERMALL) && (
                <li className="nav-item dropdown">
                  <button className="nav-link nav-btn dropdown-toggle" id="navbarDropdownSettings" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    各種設定
                  </button>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownSettings">
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'shopgroup'} onClick={handleLinkClick}>
                      店舗グループ設定
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'event'} onClick={handleLinkClick}>
                      チェックイン設定
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'stampcard'} onClick={handleLinkClick}>
                      スタンプカード設定
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'entrytype'} onClick={handleLinkClick}>
                      選択肢設定
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'applottery'} onClick={handleLinkClick}>
                      抽選設定
                    </Link>
                  </div>
                </li>
              )}
              {(user.userClass === constClass.USER_CLASS.MANAGER || user.userClass === constClass.USER_CLASS.MANAGERMALL) && (
                <li className="nav-item dropdown">
                  <button className="nav-link nav-btn dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    ポイント管理
                  </button>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'firstbonus'} onClick={handleLinkClick}>
                      初回登録特典
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'pointcampaign'} onClick={handleLinkClick}>
                      ポイントキャンペーン
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'bonuspoint'} onClick={handleLinkClick}>
                      ボーナスポイント付与
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'afterpoint'} onClick={handleLinkClick}>
                      ポイント後付け
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'monthlydownload'} onClick={handleLinkClick}>
                      月次実績検索
                    </Link>
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'rankupbonusdownload'} onClick={handleLinkClick}>
                      ランクアップ特典利用状況ダウンロード
                    </Link>
                  </div>
                </li>
              )}
              {(user.userClass === constClass.USER_CLASS.MANAGERMALL) && (
                <li className="nav-item dropdown">
                  <button className="nav-link nav-btn dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    システム管理
                  </button>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'setting'} onClick={handleLinkClick}>
                      設定マスタ
                    </Link>
                    {Common.getFunctionEnabled(setting, 'MALL') && (
                      <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'mall'} onClick={handleLinkClick}>
                        施設マスタ
                      </Link>)}
                    {Common.getFunctionEnabled(setting, 'MEMBERCARD') && (
                      <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'customerrank'} onClick={handleLinkClick}>
                        会員ランクマスタ
                      </Link>
                    )}
                    <Link className="dropdown-item" to={generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }) + 'user'} onClick={handleLinkClick}>
                      ユーザマスタ
                    </Link>
                  </div>
                </li>
              )}
              {/* マニュアル */}
              {Common.getFunctionEnabled(setting, 'MANUAL_DOWNLOAD') && (
                <li className="nav-item">
                  <a className="nav-link" href="../../pdf/ワンビル会員アプリ店舗マニュアル_Ver1.0.pdf" target="_blank" rel="noreferrer">
                    店舗マニュアル
                  </a>
                </li>
              )}
              {(user.userClass === constClass.USER_CLASS.MANAGER || user.userClass === constClass.USER_CLASS.MANAGERMALL) && Common.getFunctionEnabled(setting, 'MANUAL_DOWNLOAD') && (
                <li className="nav-item">
                  <a className="nav-link" href="../../pdf/ワンビル会員アプリ管理マニュアル_Ver1.0.pdf" target="_blank" rel="noreferrer">
                    管理マニュアル
                  </a>
                </li>
              )}
            </ul>
          </div>
        )
      }
      {
        user.isLoggedIn &&
        <div>
          <div className='small text-right text-secondary'>ver1.1.4</div>
          <label className="mr-2 text-primary">{user.userName}</label>
          <button className="btn btn-dark" onClick={handleLogoutClick}>ログアウト</button>
        </div>
      }
    </nav>
  );
}

export default NavBar;